export default __webpack_public_path__ + "static/caption-02-kr-b77a4d31ff7d36d563383a3edbf21b8d.png";